import { render, staticRenderFns } from "./EventButton.vue?vue&type=template&id=73b43d36&"
import script from "./EventButton.vue?vue&type=script&lang=js&"
export * from "./EventButton.vue?vue&type=script&lang=js&"
import style0 from "./EventButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports